export default __webpack_public_path__ + "static/media/logo1.e63b7ab6.svg";